import { render, staticRenderFns } from "./table-receiver.vue?vue&type=template&id=1506c3da&"
import script from "./table-receiver.vue?vue&type=script&lang=js&"
export * from "./table-receiver.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports